import { HttpError } from "./http-error";
import { getPublicClient } from "./web/public-client";
import { Effect } from "effect";
import { runIntent } from "./run-intent";

export const runPublicCredentials = async <A>(
  effect: Effect.Effect<A, unknown>,
): Promise<A> => {
  try {
    return await runIntent(effect);
  } catch (failure) {
    if (
      typeof failure === "object" &&
      failure !== null &&
      "code" in failure &&
      "status" in failure &&
      "message" in failure &&
      typeof failure.message === "string" &&
      typeof failure.status === "number" &&
      typeof failure.code === "string"
    ) {
      throw new HttpError(failure.message, failure.status, failure.code);
    }
    throw failure;
  }
};

export async function acceptInvite(
  email: string,
  password: string,
  token: string,
): Promise<void> {
  const client = await getPublicClient();
  await runPublicCredentials(
    client.invitations.accept({
      payload: { email: email.toLowerCase(), password, token },
    }),
  );
}

export async function acceptInviteSSO(
  email: string,
  token: string,
  provider: string,
): Promise<void> {
  const client = await getPublicClient();
  await runPublicCredentials(
    client.invitations.acceptSso({
      payload: { email: email.toLowerCase(), token, provider },
    }),
  );
}
